import { DynamicDataTable } from '../data-table.types';

export const getDatatableBuilderObjectFactory = (): DynamicDataTable => {
  return {
    singular: '',
    plural: '',
    rowActions: {},
    sizes: [],
    columns: [],
  };
};
